export const version = '1.2.0-beta.3'
